import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-dropdown.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-dropdown.component.css?ngResource";
import { Component } from '@angular/core';
let CalciteDropdownComponent = class CalciteDropdownComponent {
    constructor() { }
    ngOnInit() {
    }
    static ctorParameters = () => [];
};
CalciteDropdownComponent = __decorate([
    Component({
        selector: 'lib-calcite-dropdown',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteDropdownComponent);
export { CalciteDropdownComponent };
